import styled, { css, keyframes } from 'styled-components';
import { smLayout } from './homeStyles';
import { xlLayout } from './homeStyles';

const ImageAnimation = keyframes`
  0% {
    transform: translateZ(0) translateX(0) translateY(0);
  }
  100% {
    transform: translateZ(5px) translateX(5px) translateY(5px);
  }
`;

export const MainBox = styled.div`
  color: #ffffff;
  position: relative;
  width: ${100 / 2}%;
  height: 330px;
  border: none;
  padding: 1%;
  cursor: pointer;

  ${props =>
    props.animation === 'select' &&
    css`
      &:hover {
        & .contents_main_img_Box {
          border: 2px solid #1cdaf5;
          padding: 2px;
        }
        & .contents_main_img_Box:before {
          background: rgb(0, 0, 0, 0.1);
        }
      }
    `};
  ${props =>
    props.animation === 'move' &&
    css`
      &:hover {
        animation: ${ImageAnimation} 0.7s;
      }
    `};

  ${props =>
    props.imgOpacity &&
    css`
      & .contents_main_img_Box:before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgb(0, 0, 0, 0.2);
      }
    `};

  & .contents_main_img_Box {
    width: 100%;
    height: 100%;

    & img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }

  & .contents_main_Box {
    padding: 10px;
    display: flex;
    position: absolute;
    bottom: 10%;
    left: 3%;
    align-items: center;

    & .playBtn {
      width: 34px;
      height: 38px;
      margin-right: 5px;
    }
    & p {
      font-size: 17px;
      font-weight: bold;
    }
    & h3 {
      font-size: 16px;
      font-weight: bold;
    }
  }

  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `};

  ${props =>
    props.contetentWidth &&
    css`
      width: ${props.contetentWidth};
    `};
  ${props =>
    props.contetentHeight &&
    css`
      height: ${props.contetentHeight};
    `};

  ${props =>
    props.row &&
    css`
      flex-direction: row;
      margin-bottom: 10px;
      & > img {
        width: 30%;
      }
      & > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        & > span {
          font-size: 13px;
          color: #aaaaaa;
          margin-top: 3px;
        }
      }
    `}

  ${props =>
    (props.type === 'main-vod' || props.type === 'rec-vod') &&
    css`
      color: #ffffff;

      & .playBtn {
        width: 48px !important;
        height: 51px !important;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -17px;
        margin-left: -24px;
      }

      & .main-vod-contents-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 5px;

        & > img {
          width: 26px;
          height: 26px;
          border-radius: 50%;
        }

        & > p {
          font-size: 13px;
          color: #ffffff;
          margin-left: 5px;
        }
      }

      ${smLayout} {
        & .playBtn {
          width: 35px !important;
          height: 35px !important;
          margin-top: -9px;
          margin-left: -17px;
        }

        & .contents_main_Box {
          & h3 {
            font-size: 18px;
          }
          & p {
            font-size: 13px;
          }
        }
      }
    `}


  ${smLayout} {
    & > div {
      & h3 {
        font-size: 17px;
      }
      & p {
        font-size: 12px;
      }
    }
  }

  ${xlLayout} {
    & img {
      height: 280px;
    }
  }
`;

export const SubBox = styled.div`
  color: ${props => props.theme.text};
  width: ${100 / 4}%;
  border: none;
  padding: 1%;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  ${props =>
    props.animation === 'select' &&
    css`
      &:hover {
        & .contents_img_box {
          border: 2px solid #1cdaf5;
          padding: 2px;
        }
        & .contents_img_box:before {
          background: rgb(0, 0, 0, 0.1);
        }
      }
    `};
  ${props =>
    props.animation === 'move' &&
    css`
      &:hover {
        & img {
          animation: ${ImageAnimation} 0.7s;
        }
      }
    `};

  ${props =>
    props.imgOpacity &&
    css`
      & .contents_img_box:before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgb(0, 0, 0, 0.2);
      }

      ${props =>
        props.contetentHeight &&
        css`
          & .contents_img_box:before {
            height: ${props.contetentHeight};
          }
        `};
    `};

  ${props =>
    props.imgCenterText &&
    css`
      & .contents_img_box:after {
        content: '${props.imgCenterText}';
        position: absolute;
        color: #ffffff;
        top: 50%;
        left: 50%;
        padding: 3px 5px;
        border: 1px solid #ffffff;
        font-size: 15px;
        font-weight: bold;
        transform: translate(-50%, -50%);
      }
    `};

  & .playBtn {
    position: absolute;
    bottom: 10%;
    left: 5%;
    width: 29px;
    height: 29px;
  }

  & .vodChip {
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #f49a25;
    color: #f49a25;
    padding: 2px 8px;
    font-size: 11px !important;
    font-weight: bold;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  & img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  & article {
    padding: 10px;
  }

  ${smLayout} {
    & article {
      padding: 15px 7px 10px;
    }
  }

  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `};

  ${props =>
    props.display &&
    css`
      display: ${props.display};
    `};

  ${props =>
    props.contetentWidth &&
    css`
      & .contents_img_box {
        width: ${props.contetentWidth};
      }
    `};

  ${props =>
    props.contetentHeight &&
    css`
      & .contents_img_box {
        height: ${props.contetentHeight};
      }
    `};

  ${props =>
    props.row &&
    css`
      flex-direction: row;
      margin-bottom: 10px;
      & > img {
        width: 50%;
      }
      & > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        & > span {
          font-size: 13px;
          color: #aaaaaa;
          margin-top: 3px;
        }
      }
      & > article {
        padding: 10px;
      }
    `}

  ${props =>
    props.type === 'vod' &&
    css`
      & h1 {
        font-size: 16px;
        margin-top: 3px;
        font-weight: bold;
      }
      & span {
        font-size: 15px;
        color: ${props => props.theme.text};
      }
      & p {
        font-size: 13px;
        margin-top: 22px;
        color: ${props => props.theme.subText};
      }

      ${smLayout} {
        & h3 {
          font-size: 14px;
        }
        & h1 {
          font-size: 13px;
        }
        & span {
          font-size: 13px;
        }
        & p {
          font-size: 13px;
          margin: 8px 0 15px;
        }
      }
    `}

  ${props =>
    (props.type === 'main-vod' || props.type === 'rec-vod') &&
    css`
      color: #ffffff;

      & .main-vod {
        position: absolute;
        bottom: 15px;
        left: 10px;
      }
      & .playBtn {
        position: absolute;
        bottom: 50%;
        left: 50%;
        width: 29px;
        height: 29px;
        margin-left: -14px;
        margin-bottom: -20px;
      }

      & h1 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
      }
      & span {
        font-size: 15px;
      }

      & .main-vod-contents-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        & > img {
          width: 26px;
          height: 26px;
          border-radius: 50%;
        }

        & > p {
          font-size: 13px;
          color: ${props => props.theme.text};
          margin-left: 5px;
        }
      }

      ${smLayout} {
        & h1 {
          font-size: 15px;
        }
        & span {
          font-size: 13px;
        }

        & .main-vod-contents-box {
          & > img {
            width: 21px;
            height: 21px;
          }

          & > p {
            margin-left: 5px;
          }
        }
      }
    `}

  ${props =>
    props.type === 'sub-vod' &&
    css`
      & h1 {
        font-size: 16px;
        font-weight: bold;
        margin: 3px 0;
      }
      & p {
        font-size: 14px;

        & > b {
          font-size: 15px;
          margin-right: 5px;
          color: ${props => props.theme.subText};
          font-weight: bold;
        }
      }

      ${smLayout} {
        & h1 {
          font-size: 14px;
        }
        & p {
          font-size: 13px;

          & > b {
            font-size: 14px;
            margin-right: 3px;
          }
        }
      }
    `}

  ${props =>
    props.type === 'tide' &&
    css`
      & .tideBox {
        height: 100%;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
      }

      & h3 {
        font-size: 15px;
        font-weight: bold;
      }
      & p {
        font-size: 14px;
        color: ${props => props.theme.subText};
      }

      ${smLayout} {
        & .tideBox {
          padding: 3px 0;
        }

        & h3 {
          font-size: 14px;
        }
        & p {
          font-size: 12px;
        }
      }
    `}

    ${props =>
    props.type === 'program' &&
    css`
      & h3 {
        font-size: 14px;
        display: inline-block;
        margin-right: 5px;
        color: ${props => props.theme.subText};
      }
      & h1 {
        font-size: 16px;
        margin-top: 3px;
        font-weight: bold;
      }
      & span {
        font-size: 13px;
        color: #aaaaaa;
      }
      & p {
        font-size: 13px;
        margin-top: 22px;
        color: ${props => props.theme.subText};
      }

      ${smLayout} {
        & h3 {
          font-size: 14px;
        }
        & h1 {
          font-size: 13px;
        }
        & span {
          font-size: 13px;
        }
        & p {
          font-size: 13px;
          margin: 8px 0 15px;
        }
      }
    `}

    ${props =>
    props.type === 'today-program' &&
    css`
      & h3 {
        font-size: 15px;
        display: inline-block;
        margin-right: 5px;
        color: ${props => props.theme.subText};
      }
      & h1 {
        font-size: 14px;
        margin-top: 3px;
        font-weight: bold;
      }

      ${smLayout} {
        & section {
          display: flex;
          justify-content: space-between;
          margin-top: 3px;
        }
        & h3 {
          font-size: 14px;
        }
        & h1 {
          font-size: 13px;
        }
      }
    `}

    ${props =>
    props.type === 'vod-record' &&
    css`
      & h3 {
        font-size: 14px;
        display: inline-block;
        margin-right: 5px;
        color: ${props => props.theme.subText};
      }
      & h1 {
        font-size: 16px;
        margin: 3px 0 0 0;
        font-weight: bold;
      }
      & p {
        font-size: 13px;
        margin-top: 10px;
        color: ${props => props.theme.subText};
      }

      & span {
        font-size: 13px;
        color: #aaaaaa;
      }

      ${smLayout} {
        & h3 {
          font-size: 14px;
        }
        & h1 {
          font-size: 13px;
        }
        & p {
          font-size: 13px;
          margin: 8px 0 15px;
        }
      }
    `}


  ${props =>
    props.type === 'shopping' &&
    css`
      & h1 {
        font-size: 16px;
        margin: 3px 0 0 0;
        font-weight: bold;
      }
      & i {
        font-size: 19px;
        font-weight: bold;
        color: red;
      }
      & b {
        font-size: 18px;
        font-weight: bold;
        color: ${props => props.theme.button};
      }
      & span {
        font-size: 15px;
        text-decoration: line-through;
        padding: 0 2px;
        color: ${props => props.theme.subText};
      }

      ${smLayout} {
        & i {
          font-size: 17px;
        }
        & h1 {
          font-size: 13px;
        }
        & b {
          font-size: 16px;
        }
      }
    `}

  ${props =>
    props.type === 'vodDetail' &&
    css`
      justify-content: flex-start;

      & h3 {
        font-size: 16px;
        font-weight: bold;
        margin-right: 3px;
      }
      & h1 {
        font-size: 16px;
        margin: 0;
      }
      & b {
        font-size: 20px;
        font-weight: bold;
        color: ${props => props.theme.button};
      }
      & span {
        font-size: 13px;
        color: #aaaaaa;
      }

      ${smLayout} {
        & section {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }

        & h1 {
          font-size: 13px;
          font-weight: bold;
          margin-top: 5px;
        }
        & h3 {
          font-size: 13px;
        }
        & b {
          font-size: 20px;
        }
        & article {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        & span {
          font-size: 12px;
          padding: 0px;
        }
        & .vodChip {
          font-size: 12px;
          padding: 0px 5px;
        }
      }
    `}
  ${props =>
    props.type === 'vodDetailRow' &&
    css`
      justify-content: flex-start;
      align-items: center;

      & > article {
        padding: 26px 12px;
      }

      & h3 {
        font-size: 15px;
        font-weight: bold;
        margin-right: 3px;
      }
      & h1 {
        font-size: 13px;
        color: ${props => props.theme.disabledText};
        font-weight: bold;
      }
      & span {
        font-size: 13px;
        color: #aaaaaa;
      }

      & div > div:nth-child(3) {
        margin-top: 20px;
      }

      & .vodChip {
        padding: 2px 4px;
        font-size: 10px !important;
      }

      ${smLayout} {
        & .contents_img_box {
          flex: 1;
        }
        & .contents_Box {
          flex: 1;
        }
        & > article {
          padding-right: 0;
        }
        & h3 {
          font-size: 13px;
        }
        & h1 {
          font-size: 12px;
        }
        & span {
          font-size: 12px;
          padding: 0px;
        }

        & .vodChip {
          height: 20px;
        }
      }
    `}
    
  ${props =>
    props.type === 'vodList' &&
    css`
      & .playBtn {
        display: none;
      }
      & h1 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
      }

      ${smLayout} {
        & h1 {
          font-size: 14px;
        }
      }
    `}


    ${props =>
    props.type === 'contest' &&
    css`
      margin-bottom: 25px;

      img {
        border: 1px solid ${props => props.theme.line};
      }

      & h1 {
        font-size: 16px;
        margin-top: 3px;
        font-weight: bold;
      }
      & span {
        display: block;
        width: 100%;
        font-size: 13px;
        color: #aaaaaa;
      }
      & p {
        font-size: 14px;
        margin-top: 9px;
        padding: 2px;
        color: ${props => props.theme.button};
      }
      & nav {
        font-size: 14px;
        margin-top: 9px;
        color: #ffffff;
        display: inline-block;
        padding: 2px;
        background-color: ${props => props.theme.button};
      }

      ${smLayout} {
        & h1 {
          font-size: 13px;
        }
        & span {
          font-size: 13px;
        }
      }
    `}

    ${props =>
    props.type === 'search-program' &&
    css`
      & h1 {
        font-size: 17px;
        margin-bottom: 6px;
        color: ${props => props.theme.subText};
      }
      & h3 {
        font-size: 20px;
        font-weight: bold;
        color: ${props => props.theme.text};
      }
      & h2 {
        font-size: 18px;
        margin-bottom: 25px;
        color: ${props => props.theme.text};
      }

      & p {
        font-size: 15px;
        margin: 5px 0;
        color: ${props => props.theme.subText};
      }

      ${smLayout} {
        & h1 {
          font-size: 15px;
        }
        & h3 {
          font-size: 18px;
        }
        & h2 {
          font-size: 16px;
        }
        & p {
          font-size: 13px;
        }
      }
    `}

    ${props =>
    props.type === 'search-vod' &&
    css`
      & img {
        width: auto;
      }

      & h3 {
        font-size: 16px;
        font-weight: bold;
        color: ${props => props.theme.text};
      }
      & h2 {
        font-size: 14px;
        margin-bottom: 25px;
        color: ${props => props.theme.subText};
      }
      & p {
        font-size: 14px;
        margin: 3px 0;
        color: ${props => props.theme.subText};
      }

      ${smLayout} {
        & h3 {
          font-size: 14px;
        }
        & h2 {
          font-size: 12px;
        }
        & p {
          font-size: 12px;
        }
      }
    `}

    ${props =>
    props.type === 'search-fishing' &&
    css`
      & h3 {
        font-size: 19px;
        font-weight: bold;
        margin-bottom: 25px;
        color: ${props => props.theme.text};
      }

      & p {
        font-size: 16px;
        margin: 3px 0;
        color: ${props => props.theme.subText};
      }

      ${smLayout} {
        & h3 {
          font-size: 16px;
        }
        & p {
          font-size: 14px;
        }
      }
    `}



    ${props =>
    props.colorFix &&
    css`
      & h3 {
        color: #aaaaaa;
      }
      & h1 {
        color: #ffffff;
      }
      & span {
        color: #aaaaaa;
      }
      & p {
        color: #aaaaaa;
      }
    `}
`;

export const RecordPlayProgress = styled.span`
  height: 5px;
  position: absolute;
  bottom: -1.5px;
  left: 0;
  width: 100%;
  background-color: ${props => props.theme.subLine};

  & .progressGage {
    display: block;
    position: absolute;
    height: 5px;
    bottom: 0px;
    background-color: ${props => props.theme.button};
    ${props =>
      props.gage &&
      css`
        width: ${props.gage}%;
      `}
  }
`;

export const RecordPlayTime = styled.span`
  display: block;
  position: absolute;
  bottom: 3px;
  right: 0;
  background-color: #000000;
  color: #ffffff !important;
  font-size: 11px !important;
  padding: 1px 5px;
`;
